const pad = (num: number) => `0${num}`.slice(-2);
/**
 * Converts seconds to digital clock format (MM:SS or HH:MM:SS)
 *
 * @param secs - Number of seconds to convert
 * @returns Time string in MM:SS format (if < 1 hour) or HH:MM:SS format (if >= 1 hour)
 */
export function formatDigitalTime(secs: number): string {
	// Input validation and error handling
	if (typeof secs !== 'number' || Number.isNaN(secs) || secs < 0) {
		return '00:00';
	}

	const totalSeconds = Math.floor(secs);
	const hours = Math.floor(totalSeconds / 3600);
	const minutes = Math.floor((totalSeconds % 3600) / 60);
	const seconds = totalSeconds % 60;

	// If less than 1 hour, return MM:SS format
	if (hours === 0) {
		return `${pad(minutes)}:${pad(seconds)}`;
	}

	// If 1 hour or more, return HH:MM:SS format
	return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

export const showTrackRideTooltip = (bookingId: string) => {
	// if bookingId is in local storage, return false
	if (
		JSON.parse(localStorage.getItem('track-tooltip') || '[]').some(
			(item: { bookingId: string; timeEpoch: number }) =>
				item.bookingId === bookingId,
		)
	) {
		return false;
	}
	// delete all track-tooltip(will be array of bookingId|timeEpoch) items from local storage which is older than 30 days
	const thirtyDaysAgo = Date.now() - 30 * 24 * 60 * 60 * 1000;
	const trackTooltipItems = JSON.parse(
		localStorage.getItem('track-tooltip') || '[]',
	);
	if (trackTooltipItems) {
		trackTooltipItems.forEach(
			(item: { bookingId: string; timeEpoch: number }) => {
				if (item.bookingId === bookingId && item.timeEpoch < thirtyDaysAgo) {
					trackTooltipItems.splice(trackTooltipItems.indexOf(item), 1);
				}
			},
		);
	}
	setTrackRideTooltip(bookingId);
	return true;
};

export const setTrackRideTooltip = (bookingId: string) => {
	localStorage.setItem(
		'track-tooltip',
		JSON.stringify([{ bookingId, timeEpoch: Date.now() }]),
	);
};
